module.exports = __webpack_public_path__ + "img/bg1.4ffbf1e1.png";